import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import embeter from './embete.json'

class SearchTinglystDokument extends Component {
    state = {
        showOrderForm: false,
        isOrderEnabled: true,
        isLoaded: false,
        document: null,
        documents: [],
        isLoading: false,
        orderError: null,
        orderReference: null
    }

    componentDidMount = () =>  {
        this.kommunenummer.value = this.props.kommunenummer
    }

    formatMatrikkelnummer = eiendom => {
        if (eiendom.festenummer == 0 && eiendom.seksjonsnummer == 0) return `${eiendom.kommunenummer}-${eiendom.gardsnummer}/${eiendom.bruksnummer}`
        return `${eiendom.kommunenummer}-${eiendom.gardsnummer}/${eiendom.bruksnummer}/${eiendom.festenummer}/${eiendom.seksjonsnummer}`
    }

    search = () => {
        if (this.state.isLoading) return;        
        this.setState({document: null, isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/dokumentrettsstiftelser/`, {
            params: {
                token: this.props.token,
                kommunenummer: this.kommunenummer.value || -1,
                dokumentaar: this.dokumentaar.value || -1,
                dokumentnummer: this.dokumentnummer.value || -1,
                inkluderhistoriske: true
            }
        })
        .then(({data}) => {
            if (data.dokumenter.length == 0) {
                this.setState({document: null, isLoaded: true, isLoading: false, isOrderEnabled: false})
                return
            }

            if (data.dokumenter.length > 1) {
                this.setState({documents: data.dokumenter, isLoaded: true, isLoading: false, isOrderEnabled: false})
                return
            }

            var document = data.dokumenter[0]
            axios.get(`${this.props.settings.baseUrl}api/grunnbok/validerpantebokbestilling/`, {
                params: {
                    token: this.props.token,
                    embetenummer: document.embetenummer,
                    dokumentaar: this.dokumentaar.value || -1,
                    dokumentnummer: this.dokumentnummer.value || -1
                }
            })
            .then(({data}) => {
                this.setState({document: document, isLoaded: true, isLoading: false, isOrderEnabled: data.kanPantebokbestilles})
            })
        })
    }

    selectDocument = document => {
        if (this.state.isLoading) return;        
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/validerpantebokbestilling/`, {
            params: {
                token: this.props.token,
                embetenummer: document.embetenummer,
                dokumentaar: document.dokumentaar,
                dokumentnummer: document.dokumentnummer
            }
        })
        .then(({data}) => {
            this.setState({document: document, isLoaded: true, isLoading: false, isOrderEnabled: data.kanPantebokbestilles})
        })
    }

    showOrderForm = () => {
        if (this.state.document == null) return
        this.setState({showOrderForm: true})
    }

    sendOrder = () => {
        if (this.state.isLoading) return;
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/grunnbok/bestilltinglystdokument/`, {
            params: {
                token: this.props.token,
                embetenummer: this.state.document.embetenummer,
                navn: this.fulltnavn.value,
                dokumentaar: this.state.document.dokumentaar,
                dokumentnummer: this.state.document.dokumentnummer,
                epostadresse: this.epostadresse.value,
                fakturareferanse: this.fakturareferanse.value
            }
        })
        .then(({data}) => {
            this.setState({
                isLoading: false,
                orderError: data.feil,
                orderReference: data.referansenummer ? data.referansenummer : null
            })
        })
    }

    copyEiendommer = rettstiftelse => {
        if (rettstiftelse == null) return

        var eiendommer = [];
        rettstiftelse.eiendommer.map(e => {
            var matrikkelnummer = `${e.kommunenummer}-${e.gardsnummer}/${e.bruksnummer}`;
            if (e.festenummer || e.seksjonsnummer) matrikkelnummer += `/${e.festenummer}/${e.seksjonsnummer}`;
            eiendommer.push(matrikkelnummer)
        })

        navigator.clipboard.writeText(eiendommer.join("\n"));
    }

    render() {
        const { t } = this.props
        var documentKey = 0

        return (
            <li>
                <div className="section-header navigation" onClick={this.props.onNavigateBack}>
                    <span className="icon"><i className={"fa fa-fw fa-arrow-left"}></i></span>
                    <span className="title">{t('tilbake')}</span>
                </div>

                <div className="section-header defaultcursor">
                    <span className="icon"><i className={"fa fa-fw fa-image"}></i></span>
                    <span className="title">{t('sokettertinglystdokument')}</span>
                </div>

                { this.state.orderReference == null && !this.state.showOrderForm &&
                    <React.Fragment>
                        <div className="row section-header defaultcursor documentsearch">
                            <div className="column">
                                {t('kommunenummer')}
                            </div>
                            <div className="column">
                                {t('dokumentaar')}
                            </div>
                            <div className="column">
                                {t('dokumentnummer')}
                            </div>
                        </div>

                        <div className="row section-header defaultcursor documentsearch">
                            <div className="column number">
                                <input type="text" ref={input => this.kommunenummer = input} />
                            </div>
                            <div className="column number">
                                <input type="text" ref={input => this.dokumentaar = input} />
                            </div>
                            <div className="column number">
                                <input type="text" ref={input => this.dokumentnummer = input} />
                            </div>
                        </div>

                        <div className="section-header defaultcursor buttons">
                            <div className="button buttonspinner" onClick={this.search}>
                                <span className="icon"><i className={`${this.state.isLoading ? 'fa fa-fw fa-spinner fa-spin' : 'fa fa-fw'}`}></i></span>
                                <span>{t('sok')}</span>
                            </div>
                        </div>

                        {this.state.isLoaded && !this.state.isLoading && (!this.state.document && this.state.documents.length == 0) &&
                            <div className="section-header defaultcursor topborder">
                                <span className="title">{t('ingendokumentfunnet')}</span>
                            </div>
                        }
                        {this.state.isLoaded && !this.state.isLoading && !this.state.document && this.state.documents.length > 0 &&
                            <ul>
                                {this.state.documents.map(d => {
                                    return (
                                        <li key={d.dokumentnummer} className="section-header" onClick={() => this.selectDocument(d)}>
                                            <span className="title">{embeter[d.embetenummer]}</span>
                                        </li>
                                    )})
                                }
                            </ul>
                        }

                        {this.state.isLoaded && !this.state.isLoading && this.state.document &&
                            <React.Fragment>
                                <ul>
                                    <li className="section-header defaultcursor">
                                        <span className="title">{this.state.document.dokumentaar} - {embeter[this.state.document.embetenummer]}</span>
                                    </li>
                                {this.state.document.rettstiftelser.map(d => { return (
                                    <React.Fragment key={documentKey++}>
                                        <li key={documentKey++} className="section-header defaultcursor">
                                            <span className="title">{d.navn}</span>
                                            <div className="icon-image right"><div className="collapse"></div></div>
                                            <div className="icon-image right tooltip">
                                                <i className={"fa fa-fw fa-clipboard"} onClick={() => this.copyEiendommer(d)}></i>
                                                <div className="tooltip-content">{t('vis.kopiereiendommer')}</div>
                                            </div>
                                        </li>
                                    {d.beskrivelse != null &&
                                        <li key={documentKey++} className="section-header defaultcursor multiline">
                                                <span className="title">{d.beskrivelse}</span>
                                        </li>
                                    }
                                    {d.eiendommer.map(e => { return (
                                        <li key={documentKey++} className="section-header defaultcursor">
                                            <span className="subtitle">{this.formatMatrikkelnummer(e)}</span>
                                        </li>
                                    )})}
                                    </React.Fragment>
                                )})}
                            </ul>
                            { this.props.settings.hasGrunnbokBestilling && this.state.isOrderEnabled && !this.state.isLoading &&
                                <div className="section-header defaultcursor buttons">
                                    <div className="button" onClick={this.showOrderForm}>{t('bestilldokument')}</div>
                                </div>
                            }
                        </React.Fragment>
                        }
                    </React.Fragment>
                }

                { this.state.orderReference == null && this.state.showOrderForm &&
                    <React.Fragment>
                        <div className="section-header defaultcursor description multiline">
                            {t('registreradresse')}
                        </div>

                        <div className="section-header defaultcursor order-label topborder">
                            <span className="title">{t('fulltnavn')}</span>
                        </div>

                        <div className="section-header defaultcursor order-input">
                            <input type="text" ref={input => this.fulltnavn = input} />
                        </div>

                        <div className="section-header defaultcursor order-label">
                            <span className="title">{t('epostadresse')}</span>
                        </div>

                        <div className="section-header defaultcursor order-input">
                            <input type="text" ref={input => this.epostadresse = input} />
                        </div>

                        <div className="section-header defaultcursor order-label">
                            <span className="title">{t('fakturareferanse')}</span>
                        </div>

                        <div className="section-header defaultcursor order-input">
                            <input type="text" ref={input => this.fakturareferanse = input} />
                        </div>

                        { this.state.document.erBestilt &&
                            <div className="section-header defaultcursor description">
                                <span className="title">{t('dokumentalleredebestilt')}</span>
                            </div>
                        }

                        { this.state.orderError != null &&
                            <div className="section-header defaultcursor description multiline">
                                <span className="title">{this.state.orderError}</span>
                            </div>
                        }

                        <div className="section-header defaultcursor buttons">
                            <div className="button buttonspinner" onClick={this.sendOrder}>
                                <span className="icon"><i className={`${this.state.isLoading ? 'fa fa-fw fa-spinner fa-spin' : 'fa fa-fw'}`}></i></span>
                                <span>{t('sendbestilling')}</span>
                            </div>
                        </div>
                    </React.Fragment>
                }

                { this.state.orderReference != null &&
                    <div className="section-header defaultcursor multiline topborder">
                        <span>{t('tinglystdokumentbestilt', { dokumentaar: this.state.document.dokumentaar, dokumentnummer: this.state.document.dokumentnummer, referanse: this.state.orderReference })}</span>
                    </div>
                }
            </li>
        )
    }
}

export default withTranslation('common')(SearchTinglystDokument)